<template lang="pug">
.form-new-customer
  .close-button(v-if='removable', @click='on_remove')
    i.icon.close

  .selected-customer(v-show='form._id || form.from_card_reader')
    i.mi person
    .name
      | {{form.name}}
      i.icon.delete(v-if='cancelable', @click='cancel_select')
    .sub {{form.phone1 || '-'}}

  el-form.ui.form(:model='form', :rules='rules', ref='form')
    .four.fields
      el-form-item.ui.field.required(prop='name')
        label 姓名
        el-autocomplete(v-model='form.name', :fetch-suggestions='query_search_by("name")', custom-item='customer-item', @select='handle_select', :disabled='disabled')
      el-form-item.ui.field.required(prop='phone1')
        label 手机
        el-autocomplete(v-model='form.phone1', :fetch-suggestions='query_search_by("phone1")', custom-item='customer-item', @select='handle_select', :disabled='disabled_info')
      el-form-item.ui.field(prop='work')
        label 工作单位
        el-input(v-model='form.work', type='text', :disabled='disabled_info')
      el-form-item.ui.field(prop='gender')
        label 性别
        el-select(v-model='form.gender', :disabled='disabled')
          el-option(:key='0', label=' ', :value='0')
          el-option(:key='1', label='男', :value='1')
          el-option(:key='2', label='女', :value='2')
    .five.fields
      el-form-item.ui.field.required(prop='idcard')
        label 身份证
        el-autocomplete(v-model='form.idcard', :fetch-suggestions='query_search_by("idcard")', custom-item='customer-item', @select='handle_select', :disabled='disabled')
      el-form-item.ui.field(prop='address')
        label 身份证地址
        el-input(v-model='form.address', type='text', :disabled='disabled')
      el-form-item.ui.field(prop='contact')
        label 紧急联络人
        el-input(v-model='form.contact', type='text', :disabled='disabled_info')
      el-form-item.ui.field(prop='note')
        label 备注
        el-input(v-model='form.note', type='text', :disabled='disabled_info')
      el-form-item.ui.field(prop='population_recorded')
        label 其他
        br
        template(v-if='!disabled && $native.supported && !form.from_card_reader')
          .ui.button.teal(@click='reader_start()') 读卡
          span(style='margin-right:10px')
        el-checkbox(v-model='form.population_recorded', label='流动人口信息录入', :disabled='disabled_info')

  el-dialog(v-if='$native.supported', title='读取中', size='tiny', :visible.sync='reader_dialog', :before-close='()=>false')
    span 请将身份证放置于读卡机上
    span.dialog-footer(slot='footer')
      el-button(@click='reader_dialog = false') 取消

</template>

<script>
import Vue from 'vue'

const EMPTY_CUSTOMER = {
  _id: null,
  name: '',
  idcard: '',
  phone1: '',
  phone2: '',
  gender: 0,
  work: '',
  population_recorded: false,
  contact: '',
  note: '',
  address: '',
  from_card_reader: false,
}

Vue.component('customer-item', {
  functional: true,
  render(h, ctx) {
    const item = ctx.props.item
    ctx.data.class = 'customer-item'
    let idcard = item.idcard || ''
    if (idcard)
      idcard = `***${idcard.slice(idcard.length - 4)}`
    else
      idcard = '-'
    return h('div', ctx.data, [
      h('div', { attrs: { class: 'name' } }, [item.name]),
      h('i', { attrs: { class: 'mi' } }, ['phone']),
      h('div', { attrs: { class: 'id ' } }, [item.phone1 || '-']),
      h('br'),
      h('i', { attrs: { class: 'mi' } }, ['assignment_ind']),
      h('div', { attrs: { class: 'id ' } }, [idcard]),
    ])
  },
  props: {
    item: { type: Object, required: true },
  },
})

export default {
  name: 'form-new-customer',
  props: {
    form: {
      default() {
        return {}
      },
    },
    removable: {
      type: Boolean,
      default: false,
    },
    cancelable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: '请输入姓名' }],
        idcard: [
          { required: true, message: '请输入身份证号码' },
          { min: 18, max: 18, message: '身份证号码长度为 18', trigger: 'blur' },
        ],
        phone1: [{ required: true, message: '请输入手机/电话号码' }],
      },
      reader_dialog: false,
    }
  },
  computed: {
    disabled_info() {
      return !!this.form._id
    },
    disabled() {
      return !!this.form._id || this.form.from_card_reader
    },
    customers() {
      return this.$store.getters.customers
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      for (const key of Object.keys(EMPTY_CUSTOMER))
        this.$set(this.form, key, this.form[key] || EMPTY_CUSTOMER[key])
    },
    form_validate() {
      return new Promise((resolve, reject) => {
        if (this.form._id)
          resolve(true)
        else {
          this.$refs.form.validate((valid) => {
            if (valid)
              resolve(valid)
            else
              reject(valid)
          })
        }
      })
    },
    handle_select(item) {
      if (item && item.idcard && item._id) {
        this.form._id = item._id
        this.form.idcard = item.idcard
        this.form.name = item.name
        this.form.phone1 = item.phone1
        this.form.phone2 = item.phone2
        this.form.gender = item.gender
        this.form.work = item.work
        this.form.population_recorded = item.population_recorded
        this.form.contact = item.contact
        this.form.note = item.note
        this.form.address = item.address
        this.form.from_card_reader = item.from_card_reader || false
      }
    },
    load_customer({ _id, idcard }) {
      const customer = this.$store.state.summary.customers.filter(c => c._id === _id || c.idcard === idcard)[0]
      for (const key of Object.keys(EMPTY_CUSTOMER))
        this.$set(this.form, key, this.form[key] || customer[key])
    },
    query_search_by(key) {
      if (this.form.from_card_reader)
        return (query, callback) => callback([])

      return (query, callback) => {
        const filter = (customer) => ((customer[key] || '').indexOf(query.toLowerCase()) === 0)
        const results = query ? this.customers.filter(filter) : this.customers

        callback(results)
      }
    },
    on_remove() {
      this.$emit('remove', this.form)
    },
    reader_success({ id, name, address, gender }) {
      this.form.from_card_reader = true
      this.form.idcard = id
      this.form.name = name
      this.form.address = address
      this.form.gender = { 男: 1, 女: 2 }[gender] || 0

      this.load_customer({ idcard: id })
    },
    reader_failed({ text, name }) {
      if (text.includes('failed_to_connect'))
        text = '未找到读卡器，请确认读卡器是否连接。'
      else if (text.includes('no_card_detected'))
        text = '读卡超时，请重试。'
      if (!text && !name)
        text = '未读取到有效信息，请重试。'
      this.$alert(text)
    },
    reader_start() {
      this.reader_dialog = true
      this.$native.invoke('idcard', (response) => {
        if (this.reader_dialog) {
          if (response) {
            if (response.name && response.id) {
              this.reader_success(response)
              this.reader_dialog = false
              return
            }
          }
          this.reader_failed(response || {})
          this.reader_dialog = false
        }
      })
    },
    cancel_select() {
      this.form._id = null
      this.form.idcard = ''
      this.form.name = ''
      this.form.phone1 = ''
      this.form.phone2 = ''
      this.form.gender = ''
      this.form.work = ''
      this.form.population_recorded = false
      this.form.contact = ''
      this.form.note = ''
      this.form.address = ''
      this.form.from_card_reader = false
      this.$refs.form.resetFields()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormNewCustomer.vue?bc59b822